// @flow
import * as React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import type {PaymentProvider} from '../../../../entities';
// import {commaFormat} from '../../../../utils/number';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {actions as CheckoutActions} from '../../duck';
import type {StripeInitialization, CheckoutSummary} from '../../duck';
import type {SubscribeRequest} from '../../api';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';
import {useEffect} from 'react';
import {CircularProgress} from '@material-ui/core';
import {useHistory} from 'react-router-dom';
import {Switch} from 'react-router-dom';
import {Route} from 'react-router-dom';

export default connect(
  (state: RootState) => ({
    stripeInitialization: state.checkout.stripeInitialization,
    isInitializing: state.checkout.isInitializing,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...CheckoutActions,
      },
      dispatch
    )
)(StripeCustomPaymentButton);

type Props = {
  selectedCard: string,
  paymentProvider: PaymentProvider,
  paymentSettings: {
    currency: string,
    planId: string,
    country: string,
    amount: string,
    automaticCharge: boolean,
    savePaymentInformation: boolean,
  },
  checkoutSummary?: CheckoutSummary,
  watch: string => string,
  isPaying: boolean,
  disabled?: boolean,
  termsNConditions?: boolean,
  onSubmit: (tokenId: string) => void,
  stripeInitialize: ({subscribeRequest: SubscribeRequest}) => void,
  stripeInitialization?: StripeInitialization,
  isInitializing?: boolean,
  paymentStepAnalyticsEvent: (callback?: () => void) => void,
  paymentInfoEnteredAnalyticsEvent: (callback?: () => void) => void,
};

const useStyles = makeStyles(theme => ({
  confirmButton: {
    zIndex: 1,
    height: 48,
    margin: theme.spacing(1, 0),
    fontWeight: 600,
    fontSize: '1.125rem',
    [theme.breakpoints.down('xs')]: {
      position: 'fixed',
      left: 0,
      bottom: 64,
      margin: theme.spacing(2),
      width: `calc(100% - ${theme.spacing(4)})`,
    },
  },
  marginTop: {
    marginTop: theme.spacing(3),
  },
  loading: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
    alignSelf: 'center',
  },
}));

function StripeCustomPaymentButton(props: Props) {
  const {
    paymentProvider,
    paymentSettings,
    checkoutSummary,
    watch,
    isPaying,
    disabled,
    termsNConditions,
    onSubmit,
    selectedCard,
    stripeInitialize,
    stripeInitialization,
    isInitializing,
    paymentStepAnalyticsEvent,
    paymentInfoEnteredAnalyticsEvent,
  } = props;

  const classes = useStyles();

  const history = useHistory();

  const handleClick = e => {
    e.persist();
    if (selectedCard && selectedCard !== 'NEW') {
      onSubmit('');
    } else {
      const subscribeRequest: SubscribeRequest = {
        automaticCharge: true,
        storeTierPlanId: paymentSettings.planId,
        coupon:
          checkoutSummary && checkoutSummary.discount && checkoutSummary.coupon
            ? checkoutSummary.coupon
            : undefined,
        currency:
          paymentSettings.currency === 'PEN' ? 'USD' : paymentSettings.currency, // HARDCODE PEN TO USD
        paymentData: {
          payWithCard: false,
          billingAddress: {
            firstName: watch('firstName'),
            lastName: watch('lastName'),
            idNumber: watch('idNumber'),
            // email: data.email,
            // razonSocial:data.razonSocial,
            // ruc:data.ruc,
            address1: watch('address'),
            country: paymentSettings.country,
            admin1: watch('admin1') || undefined,
            admin2: watch('admin2') || undefined,
            admin3: watch('admin3') || undefined,
          },
          paymentProviderId: paymentProvider ? paymentProvider.id : undefined,
          processorParameters: {
            stripe: {},
            name: 'stripe',
          },
          savePaymentInformation: true,
        },
      };

      stripeInitialize({subscribeRequest});
    }
  };

  useEffect(() => {
    if (stripeInitialization && stripeInitialization.clientSecret) {
      paymentStepAnalyticsEvent(() => history.push('/checkout/payment'));
    }
  }, [history, paymentStepAnalyticsEvent, stripeInitialization]);

  return isInitializing ? (
    <CircularProgress className={classes.loading} />
  ) : (
    <Switch>
      <Route exact path="/checkout">
        <CustomButton
          variant="contained"
          className={`${classes.confirmButton} ${classes.marginTop}`}
          onClick={handleClick}
          disabled={disabled}
        >
          Proceder a pagar
        </CustomButton>
      </Route>
      <Route path="/checkout/payment">
        <CustomButton
          variant="contained"
          className={classes.confirmButton}
          form="payment-form"
          type="submit"
          disabled={disabled || isPaying || !termsNConditions}
          onClick={paymentInfoEnteredAnalyticsEvent}
        >
          {isPaying ? (
            <CircularProgress size={30} style={{alignSelf: 'center'}} />
          ) : (
            'Pagar'
          )}
        </CustomButton>
      </Route>
    </Switch>
  );
}

StripeCustomPaymentButton.propTypes = {
  selectedCard: PropTypes.string.isRequired,
  paymentProvider: PropTypes.object,
  paymentSettings: PropTypes.object,
  watch: PropTypes.func,
  checkoutSummary: PropTypes.object,
  isPaying: PropTypes.bool,
  disabled: PropTypes.bool,
  termsNConditions: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  stripeInitialize: PropTypes.func,
  stripeInitialization: PropTypes.object,
  isInitializing: PropTypes.bool,
  paymentStepAnalyticsEvent: PropTypes.func,
  paymentInfoEnteredAnalyticsEvent: PropTypes.func,
};
